import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

const useProfiles = (workspaceId: number, projectId: string | undefined, watchedOnly = false) =>
  useQuery(['profiles', workspaceId, projectId, watchedOnly], () => peApi.getProfiles(projectId, watchedOnly));

export default useProfiles;
